<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">引入人管理</h1>
            <p class="list-page-description">维护引入人资料、类型和启用状态</p>
          </div>
        </div>
      </div>

    <!-- 搜索筛选区 -->
    </template>
    <div class="list-page-table-panel mb-6">
      <PageFilterBar
        shell-class="filter-bar-shell is-embedded"
        body-class="filter-bar-body is-panel"
        :show-refresh="true"
        :refresh-loading="loading"
        @refresh="fetchData"
      >
          <div class="filter-bar-field is-wide relative">
            <input
              v-model="queryParams.name"
              type="text"
              placeholder="搜索引入人姓名"
              class="form-search-input form-control-sm w-full"
              @keyup.enter="handleSearch"
            >
            <svg class="absolute left-3 top-2.5 h-4 w-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
          </div>
          <input
            v-model="queryParams.phone"
            type="text"
            placeholder="搜索联系电话"
            class="form-input form-control-sm filter-bar-field"
          >
          <el-select
            v-model="queryParams.referrerType"
            placeholder="请选择类型"
            class="form-select form-control-sm filter-bar-field"
          >
            <el-option label="全部类型" value="" />
            <el-option label="渠道" value="0" />
            <el-option label="客户转介绍" value="1" />
            <el-option label="政府" value="2" />
            <el-option label="其他" value="3" />
          </el-select>
          <el-select
            v-model="queryParams.status"
            placeholder="请选择状态"
            class="form-select form-control-sm filter-bar-field"
          >
            <el-option label="全部状态" value="" />
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>

        <template #searchActions>
          <button
            @click="handleSearch"
            class="btn-primary"
          >
            搜索
          </button>
          <button
            @click="handleReset"
            class="btn-secondary"
          >
            重置
          </button>
        </template>
      </PageFilterBar>

      <!-- 操作栏 -->
      <div class="px-6 py-4 flex items-center justify-between border-b border-slate-200">
        <div class="text-sm text-slate-600">
          共 <span class="font-medium text-slate-900">{{ total }}</span> 条引入人
        </div>
        <button
          v-permission="'referrer:add'"
          @click="handleAdd"
          class="btn-primary"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          新增引入人
        </button>
      </div>

      <!-- 数据表格 -->
      <div class="data-table-shell">
        <div class="data-table-scroll">
          <table class="data-table text-sm">
            <thead class="data-table-head">
              <tr>
                <th class="data-table-th text-left">引入人姓名</th>
                <th class="data-table-th text-left">联系电话</th>
                <th class="data-table-th text-left">微信号</th>
                <th class="data-table-th text-left">引入类型</th>
                <th class="data-table-th text-right">累计客户数</th>
                <th class="data-table-th text-left">状态</th>
                <th class="data-table-th text-left">创建时间</th>
                <th class="data-table-th text-left">备注</th>
                <th class="data-table-th text-center w-32">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" class="data-table-td is-center">
                  <div class="flex flex-col items-center justify-center">
                    <div class="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mb-3"></div>
                    <span class="text-slate-500">加载中...</span>
                  </div>
                </td>
              </tr>
              <tr v-else-if="list.length === 0">
                <td colspan="9" class="data-table-empty">
                  <div class="flex flex-col items-center justify-center">
                    <svg class="w-12 h-12 text-slate-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                    </svg>
                    <span>暂无数据</span>
                  </div>
                </td>
              </tr>
              <tr
                v-for="item in list"
                :key="item.id"
                class="data-table-row"
              >
                <td class="data-table-td">
                  <div class="font-medium text-slate-900">{{ item.name }}</div>
                </td>
                <td class="data-table-td text-slate-600">{{ item.phone }}</td>
                <td class="data-table-td text-slate-600">{{ item.wechat || '-' }}</td>
                <td class="data-table-td">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    :class="{
                      'bg-blue-100 text-blue-800': item.referrerType === '0',
                      'bg-green-100 text-green-800': item.referrerType === '1',
                      'bg-purple-100 text-purple-800': item.referrerType === '2',
                      'bg-gray-100 text-gray-800': item.referrerType === '3'
                    }"
                  >
                    {{ item.referrerTypeName || getReferrerTypeName(item.referrerType) }}
                  </span>
                </td>
                <td class="data-table-td is-right text-slate-600">{{ item.totalCustomerCount || 0 }}</td>
                <td class="data-table-td">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer"
                    :class="{
                      'bg-green-100 text-green-800': item.status === 1,
                      'bg-red-100 text-red-800': item.status === 0
                    }"
                    @click="handleToggleStatus(item)"
                  >
                    {{ item.statusName || (item.status === 1 ? '启用' : '禁用') }}
                  </span>
                </td>
                <td class="data-table-td text-slate-600">{{ formatTime(item.createTime) }}</td>
                <td class="data-table-td text-slate-600 max-w-[200px] truncate" :title="item.remark">
                  {{ item.remark || '-' }}
                </td>
                <td class="data-table-td is-center">
                  <div class="flex items-center justify-center gap-1">
                    <button
                      @click="handleViewDetail(item)"
                      class="table-action-button is-primary"
                      title="详情" aria-label="详情"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </button>
                    <button
                      v-permission="'referrer:edit'"
                      @click="handleEdit(item)"
                      class="table-action-button is-primary"
                      title="编辑" aria-label="编辑"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button
                      v-permission="'referrer:delete'"
                      @click="handleDelete(item)"
                      class="table-action-button is-danger"
                      title="删除" aria-label="删除"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                    <button
                      @click="handleBindAppUserOpen(item)"
                      class="table-action-button is-primary"
                      title="绑定APP用户" aria-label="绑定APP用户"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 分页 -->
      <AppPagination
        class="pagination-bridge"
        v-if="list.length > 0"
        :pagination="pagination"
        :page-sizes="[10, 20, 50]"
        total-label="共 "
        total-suffix=" 条引入人"
        @page-change="handlePageChange"
        @size-change="handlePageSizeChange"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <ReferrerFormModal
      v-model:visible="formModalVisible"
      :referrer-data="currentReferrer"
      @success="handleFormSuccess"
    />

    <!-- 详情弹窗 -->
    <ReferrerDetailModal
      v-model:visible="detailModalVisible"
      :referrer-id="currentReferrerId"
      :referrer-info="currentReferrer"
    />

    <!-- 绑定APP用户弹窗 -->
    <el-dialog
      v-model="bindDialogVisible"
      width="560px"
      align-center
      :close-on-click-modal="false"
    >
      <template #header>
        <div class="flex items-center gap-3">
          <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 ring-1 ring-primary-100">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
            </svg>
          </div>
          <div class="min-w-0">
            <div class="text-lg font-semibold leading-6 text-slate-900">绑定APP用户</div>
            <div class="mt-1 text-sm text-slate-500">{{ bindStateLoadFailed ? '绑定状态加载失败' : (boundAppUser ? '当前引入人已存在绑定关系' : '当前引入人尚未绑定APP用户') }}</div>
          </div>
        </div>
      </template>

      <div v-if="bindLoading" class="flex min-h-[220px] items-center justify-center">
        <div class="flex flex-col items-center gap-3 text-slate-500">
          <div class="h-9 w-9 animate-spin rounded-full border-4 border-primary-600 border-t-transparent"></div>
          <span class="text-sm">加载中...</span>
        </div>
      </div>
      <div v-else class="space-y-4">
        <div class="rounded-lg border border-slate-200 bg-slate-50 px-4 py-3">
          <div class="flex items-center justify-between gap-3">
            <div class="min-w-0">
              <div class="text-xs font-medium uppercase text-slate-500">引入人</div>
              <div class="mt-1 truncate text-base font-semibold text-slate-900">{{ currentReferrer?.name || '-' }}</div>
              <div class="mt-0.5 text-sm text-slate-500">{{ currentReferrer?.phone || '-' }}</div>
            </div>
            <span
              class="inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-xs font-medium"
              :class="boundAppUser ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'"
            >
              {{ boundAppUser ? '已绑定' : '未绑定' }}
            </span>
          </div>
        </div>

        <div v-if="bindStateLoadFailed" class="rounded-lg border border-rose-200 bg-rose-50 px-4 py-4">
          <div class="flex items-start gap-3">
            <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white text-rose-600 ring-1 ring-rose-100">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3.75m0 3.75h.007v.008H12v-.008zM10.29 3.86L1.82 18a1.5 1.5 0 001.29 2.25h17.78A1.5 1.5 0 0022.18 18L13.71 3.86a1.5 1.5 0 00-2.42 0z"/>
              </svg>
            </div>
            <div class="min-w-0">
              <div class="font-semibold text-rose-700">绑定状态加载失败</div>
              <div class="mt-1 text-sm text-rose-600">无法确认当前引入人是否已有绑定，请关闭后重试。</div>
            </div>
          </div>
        </div>

        <div v-else-if="boundAppUser" class="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-4">
          <div class="mb-3 flex items-center gap-2 text-sm font-medium text-emerald-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            已绑定用户
          </div>
          <div class="flex items-center gap-3">
            <img
              v-if="boundAppUser.avatar"
              :src="boundAppUser.avatar"
              class="h-12 w-12 rounded-full object-cover ring-2 ring-white"
            >
            <div v-else class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white text-slate-400 ring-1 ring-emerald-100">
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <div class="min-w-0">
              <div class="truncate text-base font-semibold text-slate-900">{{ boundAppUser.nickname || '未设置昵称' }}</div>
              <div class="mt-0.5 text-sm text-slate-600">{{ boundAppUser.phone }}</div>
            </div>
          </div>
        </div>

        <div v-else-if="canOperateAppUserBinding(currentReferrer) && appUserCandidate" class="rounded-lg border border-primary-200 bg-primary-50 px-4 py-4">
          <div class="mb-3 flex items-center justify-between gap-3">
            <div class="flex items-center gap-2 text-sm font-medium text-primary-700">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V6a4 4 0 118 0v1m-9 4h10m-8 4h6m-8 4h10a2 2 0 002-2V9a2 2 0 00-2-2H7a2 2 0 00-2 2v8a2 2 0 002 2z"/>
              </svg>
              发现匹配用户
            </div>
            <span class="shrink-0 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-primary-700 ring-1 ring-primary-100">
              同手机号
            </span>
          </div>
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
            <div class="flex min-w-0 flex-1 items-center gap-3">
              <img
                v-if="appUserCandidate.avatar"
                :src="appUserCandidate.avatar"
                class="h-12 w-12 rounded-full object-cover ring-2 ring-white"
              >
              <div v-else class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white text-slate-400 ring-1 ring-primary-100">
                <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                </svg>
              </div>
              <div class="min-w-0">
                <div class="truncate whitespace-nowrap text-base font-semibold text-slate-900" :title="appUserCandidate.nickname || '未设置昵称'">{{ appUserCandidate.nickname || '未设置昵称' }}</div>
                <div class="mt-0.5 truncate whitespace-nowrap text-sm text-slate-600" :title="appUserCandidate.phone || '-'">{{ appUserCandidate.phone || '-' }}</div>
              </div>
            </div>
            <button
              @click="handleBindAppUserCandidate"
              class="btn-primary shrink-0 self-stretch whitespace-nowrap sm:self-auto sm:min-w-[96px]"
              type="button"
              :disabled="bindSubmitLoading"
            >
              {{ bindSubmitLoading ? '绑定中...' : '直接绑定' }}
            </button>
          </div>
        </div>

        <div v-if="canOperateAppUserBinding(currentReferrer) && !boundAppUser && !bindStateLoadFailed" class="rounded-lg border border-slate-200 bg-white px-4 py-4">
          <div class="mb-3 flex items-center gap-2 text-sm font-medium text-slate-700">
            <svg class="h-4 w-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.5 8.25h9m-9 3.75h6m-6 3.75h9M5.25 4.5h13.5A1.5 1.5 0 0120.25 6v12a1.5 1.5 0 01-1.5 1.5H5.25A1.5 1.5 0 013.75 18V6a1.5 1.5 0 011.5-1.5z"/>
            </svg>
            手动绑定
          </div>
          <el-form
            ref="bindFormRef"
            :model="bindForm"
            :rules="bindFormRules"
            label-position="top"
          >
            <el-form-item label="APP用户手机号" prop="phone" class="mb-0">
              <el-input
                v-model="bindForm.phone"
                placeholder="请输入APP用户手机号"
                maxlength="11"
                show-word-limit
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <template #footer v-if="!bindLoading">
        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            @click="bindDialogVisible = false"
            class="btn-secondary w-full sm:w-auto"
            type="button"
          >
            {{ boundAppUser ? '关闭' : '取消' }}
          </button>
          <button
            v-if="boundAppUser && canOperateAppUserBinding(currentReferrer)"
            @click="handleUnbindAppUser"
            class="btn-danger-secondary w-full sm:w-auto"
            type="button"
            :disabled="bindSubmitLoading"
          >
            解除绑定
          </button>
          <button
            v-if="canOperateAppUserBinding(currentReferrer) && !boundAppUser && !bindStateLoadFailed"
            @click="handleBindAppUser"
            class="btn-primary w-full sm:w-auto"
            type="button"
            :disabled="bindSubmitLoading"
          >
            {{ bindSubmitLoading ? '绑定中...' : '按手机号绑定' }}
          </button>
        </div>
      </template>
    </el-dialog>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getReferrerPage, updateReferrerStatus, deleteReferrer, bindAppUser, getReferrerAppUser, getReferrerAppUserCandidate, bindReferrerAppUserCandidate, unbindAppUser } from '@/api/referrer'
import { useUserStore } from '@/stores/user'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'
import ReferrerFormModal from '@/components/ReferrerFormModal.vue'
import ReferrerDetailModal from './components/ReferrerDetailModal.vue'

const userStore = useUserStore()

// 引入人类型映射
const referrerTypeMap = {
  '0': '渠道',
  '1': '客户转介绍',
  '2': '政府',
  '3': '其他'
}

const getReferrerTypeName = (type) => {
  return referrerTypeMap[type] || '-'
}

// 格式化时间
const formatTime = (time) => {
  if (!time) return '-'
  return new Date(time).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// 数据列表
const list = ref([])
const loading = ref(false)
const total = ref(0)

// 查询参数
const queryParams = reactive({
  name: '',
  phone: '',
  referrerType: '',
  status: ''
})

// 分页
const pagination = reactive({
  current: 1,
  size: 10,
  pages: 1
})

// 表单弹窗
const formModalVisible = ref(false)
const currentReferrer = ref(null)

// 详情弹窗
const detailModalVisible = ref(false)
const currentReferrerId = ref(null)

// 绑定APP用户弹窗
const bindDialogVisible = ref(false)
const bindLoading = ref(false)
const bindSubmitLoading = ref(false)
const bindFormRef = ref(null)
const bindForm = reactive({
  referrerId: null,
  phone: ''
})
const bindFormRules = {
  phone: [
    { required: true, message: '请输入APP用户手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
  ]
}
const boundAppUser = ref(null)
const appUserCandidate = ref(null)
const bindStateLoadFailed = ref(false)

// 计算可见页码

// 加载数据
const fetchData = async () => {
  loading.value = true
  try {
    const params = {
      page: pagination.current,
      size: pagination.size,
      ...Object.fromEntries(
        Object.entries(queryParams).filter(([, v]) => v !== '' && v !== null && v !== undefined)
      )
    }
    const data = await getReferrerPage(params)
    list.value = data.records || []
    total.value = data.total || 0
    pagination.pages = data.pages || 1
  } catch (error) {
    console.error('获取引入人列表失败:', error)
    ElMessage.error(error.message || '获取引入人列表失败')
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  pagination.current = 1
  fetchData()
}

// 重置
const handleReset = () => {
  queryParams.name = ''
  queryParams.phone = ''
  queryParams.referrerType = ''
  queryParams.status = ''
  pagination.current = 1
  fetchData()
}

// 分页
const handlePageChange = (page) => {
  if (page < 1 || page > pagination.pages) return
  pagination.current = page
  fetchData()
}

const handlePageSizeChange = (size) => {
  pagination.size = size
  pagination.current = 1
  fetchData()
}

// 新增
const handleAdd = () => {
  currentReferrer.value = null
  formModalVisible.value = true
}

// 编辑
const handleEdit = (item) => {
  currentReferrer.value = { ...item }
  formModalVisible.value = true
}

// 查看详情
const handleViewDetail = (item) => {
  currentReferrer.value = { ...item }
  currentReferrerId.value = item.id
  detailModalVisible.value = true
}

const canOperateAppUserBinding = (item) => {
  const createUserId = item?.createUserId
  const currentUserId = userStore.userInfo?.userId
  if (createUserId === null || createUserId === undefined) return false
  if (currentUserId === null || currentUserId === undefined) return false
  return String(createUserId) === String(currentUserId)
}

// 删除
const handleDelete = async (item) => {
  try {
    await ElMessageBox.confirm(
      `确定要删除引入人「${item.name}」吗？`,
      '删除确认',
      {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    await deleteReferrer(item.id)
    ElMessage.success('删除成功')
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除引入人失败:', error)
      ElMessage.error(error.message || '删除引入人失败')
    }
  }
}

// 切换状态
const handleToggleStatus = async (item) => {
  const newStatus = item.status === 1 ? 0 : 1
  const statusText = newStatus === 1 ? '启用' : '禁用'

  try {
    await ElMessageBox.confirm(
      `确定要${statusText}引入人「${item.name}」吗？`,
      '状态切换',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    await updateReferrerStatus(item.id, newStatus)
    ElMessage.success(`${statusText}成功`)
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('切换状态失败:', error)
      ElMessage.error(error.message || '切换状态失败')
    }
  }
}

const loadAppUserCandidate = async (referrerId) => {
  appUserCandidate.value = null
  if (!referrerId) return

  try {
    const data = await getReferrerAppUserCandidate(referrerId)
    appUserCandidate.value = data || null
  } catch (error) {
    appUserCandidate.value = null
    console.error('查询匹配APP用户失败:', error)
  }
}

const promptBindCandidateAfterCreate = async (referrer) => {
  if (!referrer?.id) return

  let candidate = null
  try {
    candidate = await getReferrerAppUserCandidate(referrer.id)
  } catch (error) {
    console.error('查询新建引入人匹配APP用户失败:', error)
    return
  }
  if (!candidate) return

  try {
    const candidateName = candidate.nickname || '未设置昵称'
    const candidatePhone = candidate.phone || referrer.phone || '-'
    await ElMessageBox.confirm(
      `检测到相同手机号的APP用户「${candidateName}」（${candidatePhone}），是否需要直接绑定？`,
      '绑定APP用户',
      {
        confirmButtonText: '直接绑定',
        cancelButtonText: '暂不绑定',
        type: 'info'
      }
    )
    await bindReferrerAppUserCandidate(referrer.id)
    ElMessage.success('绑定成功')
    fetchData()
  } catch (error) {
    if (error !== 'cancel' && error !== 'close') {
      console.error('创建后快速绑定APP用户失败:', error)
      ElMessage.error(error.message || '绑定APP用户失败')
    }
  }
}

// 表单提交成功
const handleFormSuccess = async (event) => {
  await fetchData()
  if (event?.action === 'create') {
    await promptBindCandidateAfterCreate(event?.referrer)
  }
}

// 绑定APP用户
const handleBindAppUserOpen = async (item) => {
  currentReferrer.value = { ...item }
  bindForm.referrerId = item.id
  bindForm.phone = ''
  boundAppUser.value = null
  appUserCandidate.value = null
  bindStateLoadFailed.value = false
  bindDialogVisible.value = true
  bindLoading.value = true
  try {
    const data = await getReferrerAppUser(item.id)
    boundAppUser.value = data || null
    if (!boundAppUser.value && canOperateAppUserBinding(currentReferrer.value)) {
      await loadAppUserCandidate(item.id)
    }
  } catch (error) {
    boundAppUser.value = null
    appUserCandidate.value = null
    bindStateLoadFailed.value = true
    console.error('获取APP用户绑定状态失败:', error)
    ElMessage.error('获取APP用户绑定状态失败，请稍后重试')
  } finally {
    bindLoading.value = false
  }
}

const handleBindAppUser = async () => {
  if (!canOperateAppUserBinding(currentReferrer.value)) {
    ElMessage.error('只有创建人才能操作引入人APP用户绑定')
    return
  }
  if (bindStateLoadFailed.value) {
    ElMessage.error('绑定状态加载失败，请关闭后重试')
    return
  }
  const valid = await bindFormRef.value.validate().catch(() => false)
  if (!valid) return

  bindSubmitLoading.value = true
  try {
    await bindAppUser(currentReferrer.value.id, {
      referrerId: bindForm.referrerId,
      phone: bindForm.phone
    })
    ElMessage.success('绑定成功')
    bindDialogVisible.value = false
    fetchData()
  } catch (error) {
    console.error('绑定APP用户失败:', error)
    ElMessage.error(error.message || '绑定APP用户失败')
  } finally {
    bindSubmitLoading.value = false
  }
}

const handleBindAppUserCandidate = async () => {
  if (!currentReferrer.value?.id) return
  if (!canOperateAppUserBinding(currentReferrer.value)) {
    ElMessage.error('只有创建人才能操作引入人APP用户绑定')
    return
  }
  if (bindStateLoadFailed.value) {
    ElMessage.error('绑定状态加载失败，请关闭后重试')
    return
  }

  bindSubmitLoading.value = true
  try {
    await bindReferrerAppUserCandidate(currentReferrer.value.id)
    ElMessage.success('绑定成功')
    bindDialogVisible.value = false
    fetchData()
  } catch (error) {
    console.error('快速绑定APP用户失败:', error)
    ElMessage.error(error.message || '快速绑定APP用户失败')
  } finally {
    bindSubmitLoading.value = false
  }
}

const handleUnbindAppUser = async () => {
  if (!canOperateAppUserBinding(currentReferrer.value)) {
    ElMessage.error('只有创建人才能操作引入人APP用户绑定')
    return
  }
  try {
    await ElMessageBox.confirm(
      `确定要解除「${currentReferrer.value?.name}」的APP用户绑定吗？`,
      '解除绑定',
      {
        confirmButtonText: '确定解除',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    await unbindAppUser(currentReferrer.value.id)
    ElMessage.success('解除绑定成功')
    boundAppUser.value = null
    await loadAppUserCandidate(currentReferrer.value.id)
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('解除绑定失败:', error)
      ElMessage.error(error.message || '解除绑定失败')
    }
  }
}

// 初始化
onMounted(() => {
  fetchData()
})
</script>
